import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";

export const getGeneralDonation = (type: string, name: string) =>
  createAsyncThunk(name, async () => {
    try {
      const response = await axios.post(`${baseUrlApi}general_donations`, {
        headers: {
          "Content-Type": "application/json",
        },
        type,
      });

      return response?.data;
    } catch (error) {
      throw error;
    }
  });

export const getHomePageGeneralDonations = getGeneralDonation(
  "homepage",
  "general_donation"
);

export const getAllGeneralDonations = getGeneralDonation("all", "all");
export const getCompletedGeneralDonation = getGeneralDonation(
  "completed",
  "completed"
);

export const getDetailsGeneralDonation = createAsyncThunk(
  "generalDonation/getDetails",
  async (access_token: string | undefined) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}general_donation`,
        { access_token: access_token },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const getGeneralDonationTypes = createAsyncThunk(
  "generalDonation/types",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}general_donation/types`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getDonationTypes = createAsyncThunk(
  "generaldonation/types",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}donation/general/types`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
